<template>
  <!-- event categories -->
  <SList>
    <SListItem
      v-for="(category, key) in categories"
      :key="key"
      :data-cy="`category-${key}`"
      :title="$t(category.value)"
      :icon="category.icon"
      icon-color="dark"
      :aria-pressed="selectedCategory === key ? 'true' : 'false'"
      @click.prevent="selectedCategory = key"
    >
      <template #right-action>
        <SRadioButton
          name="categories"
          :currently-selected-value="selectedCategory"
          :label-text="$t(category.value)"
          checkbox-type="round"
          :value-on-selection="key"
        />
      </template>
    </SListItem>
  </SList>
</template>

<script>
import { categories } from 'src/views/Channels/Calendar/calendarCategories.js'
import SRadioButton from 'src/components/base/SRadioButton.vue'

export default {
  name: 'EventCreationModalCategories',
  components: { SRadioButton },
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    selectedCategory: null,
    categories,
  }),

  emits: ['update'],

  methods: {
    update() {
      // Update event in wrapper component
      this.$emit('update', {
        ...this.event,
        category: this.selectedCategory,
      })
      this.$router.go(-1)
    },
  },

  watch: {
    selectedCategory: {
      handler: function () {
        if (this.selectedCategory === this.event.category) return
        this.update()
      },
    },

    event: {
      handler: function (newVal, oldVal) {
        if (!newVal.category || newVal.category === oldVal?.category) return
        this.selectedCategory = this.$clone(this.event.category)
      },

      immediate: true,
    },
  },
}
</script>
